import 'intersection-observer'

// 滚动曝光
// https://developer.mozilla.org/zh-CN/docs/Web/API/Intersection_Observer_API
class Exposure {
  constructor() {
    this._observer = null
    this.exposureStateMaps = new Map()
  }

  isIntersecting(entry) {
    if (entry.isIntersecting && entry.intersectionRatio >= 0) return true
    if (entry.isIntersecting === undefined) return true
    return false
  }

  setObserver({ threshold = 0.5, callback, exposureType = 'once' }) {
    if (this._observer) return
    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const target = entry.target
          if (
            this.isIntersecting(entry) &&
            entry.intersectionRatio >= threshold
          ) {
            if (exposureType === 'once') {
              if (!this.exposureStateMaps.get(target)) {
                callback && callback(target)
                this.exposureStateMaps.set(target, true)
              }
            } else {
              callback && callback(target)
            }
          }
        })
      },
      {
        root: null,
        threshold: [threshold],
      }
    )
  }
  /**
   * @param {*} options
   * threshold: 交叉比例, 默认为1
   * ele：滚动的元素或元素集合
   * callback：回调函数
   * exposureType： 曝光类型，反复曝光 repeat / 单次曝光 once 默认单次曝光
   */
  observer(options = {}) {
    let { ele } = options
    if (!ele) {
      return
    }
    if (!this._observer) {
      this.setObserver(options)
    }
    if (ele instanceof Node) {
      this._observer.observe(ele)
      this.exposureStateMaps.set(ele, false)
    }
    if (ele instanceof NodeList) {
      const targetArr = Array.prototype.slice.call(ele)
      targetArr.forEach((element) => {
        this._observer.observe(element)
        this.exposureStateMaps.set(element, false)
      })
    }
  }

  // 终止对所有目标元素可见性变化的观察
  disconnect() {
    this._observer && this._observer.disconnect()
  }

  // 停止对一个元素的观察
  unobserve(elements) {
    if (!elements) {
      return
    }
    if (elements instanceof Node) {
      this._observer.unobserve(elements)
    }
    if (elements instanceof NodeList) {
      const targetArr = Array.prototype.slice.call(elements)
      targetArr.forEach((element) => {
        this._observer.unobserve(element)
      })
    }
  }

  destory() {
    this._observer && this._observer.disconnect()
    this._observer = null
    this.exposureStateMaps.clear()
  }
}

export default Exposure

// 使用示例

// const exposure = new Exposure()
// exposure.observer({
//   threshold: 1, //交叉比例, 默认为1
//   exposureType: 'repeat',  // 曝光类型，反复曝光repeat / 单次曝光once, 默认单次曝光
//   ele: '', // 要监测的元素，可以是单个元素，也可以是nodelist
//   callback: (el) => { // 回调

//   }
// })
